import {client} from '../helpers/api';

export async function getCheckAnnouncement() {
  const response = await client.get('/api/check-announcement');

  if (response.data?.status) {
    return response.data?.result;
  } else if (response.data?.status === false) {
    throw response.data?.message || '';
  }
  throw response;
}
